import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import searchIconGrey from "../../assets/images/common/searchIconGrey.svg";
import { setNavbarSearch } from "../../redux/features/sidebar/sidebarSlice";
import { filterResetUrlExceptions } from "../../utils/shared/variables";
import {
  fetchAllClassicalQuestionsList,
  fetchLastClassicalQuestionsList,
  fetchProgramQuestions,
  fetchRecommendedClassicalQuestionsList,
  fetchTournamentsList,
} from "../common/ApiMethods";

function NavbarSearchInput({ isSearchVisible }) {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navbarSearch = useSelector((e) => e.sidebar.navbarSearch);
  const userOrganization = useSelector((e) => e.sidebar.organisation);

  // Program states
  const programListPageSize = useSelector(
    (e) => e.programs.programListPageSize
  );
  const sortOrderBy = useSelector((e) => e.programs.sortOrderBy);
  const selectedComplexityFilter = useSelector(
    (e) => e.programs.selectedComplexityFilter
  );
  const selectedRoleFilter = useSelector((e) => e.programs.selectedRoleFilter);
  const selectedCategoryFilter = useSelector(
    (e) => e.programs.selectedCategoryFilter
  );
  const selectedLearnPointFilter = useSelector(
    (e) => e.programs.selectedLearnPointFilter
  );
  const selectedModuleFilter = useSelector(
    (e) => e.programs.selectedModuleFilter
  );
  const selectedStatusFilter = useSelector(
    (e) => e.programs.selectedStatusFilter
  );
  const programQuesPageSize = useSelector(
    (e) => e.programs.programQuesPageSize
  );

  const questionTagFilter = useSelector((e) => e.programs.questionTagFilter);

  // Tournament states
  const tournamentListPageSize = useSelector(
    (e) => e.tournaments.tournamentListPageSize
  );
  const tournamentSortOrderBy = useSelector((e) => e.tournaments.sortOrderBy);
  const classicalQuesPage = useSelector((e) => e.tournaments.classicalQuesPage);
  const classicalQuesPageSize = useSelector(
    (e) => e.tournaments.classicalQuesPageSize
  );
  const classicalUnassignedQuesPage = useSelector(
    (e) => e.tournaments.classicalUnassignedQuesPage
  );
  const classicalUnassignedQuesPageSize = useSelector(
    (e) => e.tournaments.classicalUnassignedQuesPageSize
  );
  const classicalLastQuesPage = useSelector(
    (e) => e.tournaments.classicalLastQuesPage
  );
  const classicalLastQuesPageSize = useSelector(
    (e) => e.tournaments.classicalLastQuesPageSize
  );
  const tournamentDetail = useSelector((e) => e.tournaments.tournamentDetail);
  const selectedQuesTypeFilter = useSelector(
    (e) => e.programs.selectedQuesTypeFilter
  );
  const selectedLastAssignedDate = useSelector(
    (e) => e.programs.selectedLastAssignedDate
  );

  const urlExceptions = ["/programs/questions"];

  // Reset navbar search on route change
  useEffect(() => {
    const shouldExclude = filterResetUrlExceptions.some((regex) =>
      regex.test(location.pathname)
    );
    if (!shouldExclude) {
      dispatch(setNavbarSearch(""));
    }
  }, [location.pathname, dispatch]);

  // Fired when search input entered
  const searchData = (searchInput) => {
    dispatch(setNavbarSearch(searchInput));
    switch (true) {
      case location?.pathname.includes(
        `/tournaments/${params.TournamentId}/contest`
      ):
        if (tournamentDetail?.organization) {
          fetchRecommendedClassicalQuestionsList(
            dispatch,
            tournamentDetail.organization,
            tournamentDetail.roles,
            classicalUnassignedQuesPage,
            classicalUnassignedQuesPageSize,
            searchInput,
            selectedCategoryFilter,
            selectedLearnPointFilter,
            selectedQuesTypeFilter
          );
          fetchAllClassicalQuestionsList(
            dispatch,
            tournamentDetail.organization,
            classicalQuesPage,
            classicalQuesPageSize,
            searchInput,
            selectedRoleFilter,
            selectedCategoryFilter,
            selectedLearnPointFilter,
            selectedQuesTypeFilter,
            selectedLastAssignedDate
          );
          fetchLastClassicalQuestionsList(
            dispatch,
            tournamentDetail.organization,
            classicalLastQuesPage,
            classicalLastQuesPageSize,
            searchInput,
            selectedRoleFilter,
            selectedCategoryFilter,
            selectedLearnPointFilter,
            selectedQuesTypeFilter,
            selectedLastAssignedDate
          );
        }
        break;
      case location?.pathname.includes("tournaments/list"):
        fetchTournamentsList(
          dispatch,
          1,
          tournamentListPageSize,
          userOrganization,
          tournamentSortOrderBy,
          searchInput
        );
        break;
      case location?.pathname.includes("programs/questions"):
        fetchProgramQuestions(
          dispatch,
          1,
          programQuesPageSize,
          userOrganization,
          sortOrderBy,
          selectedStatusFilter,
          selectedModuleFilter,
          selectedRoleFilter,
          selectedCategoryFilter,
          selectedLearnPointFilter,
          questionTagFilter,
          searchInput
        );
        break;
      default:
        break;
    }
  };

  // Component for navbar search
  return (
    <div
      style={{ display: isSearchVisible ? "block" : "none" }}
      className="dt-ta-common-search-otr">
      <div className="d-flex dt-ta-common-search">
        <img src={searchIconGrey} alt="search_icon" />
        <input
          style={{ width: "94%" }}
          placeholder="Search"
          type="text"
          value={navbarSearch}
          onChange={(event) => {
            searchData(event.target.value);
          }}
        />
      </div>
    </div>
  );
}

NavbarSearchInput.propTypes = {
  isSearchVisible: PropTypes.bool,
};

// Define default props
NavbarSearchInput.defaultProps = {
  isSearchVisible: false,
};

export default NavbarSearchInput;
